// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"055f8427","787":"14b1af16"}[chunkId] + ".chunk.js";
};